module.exports = __webpack_public_path__ + "img/safe_tool_10.b8b10085.jpg";